import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { isNavItemActive, mainNav } from '../data/siteNav';

function Mobilemenu({ onClose }) {
  const location = useLocation();
  const [openItem, setOpenItem] = useState('');

  const closeMenu = () => {
    if (onClose) onClose();
  };

  return (
    <nav className="eduya-mobile-nav" aria-label="Mobile">
      <ul className="eduya-mobile-list">
        {mainNav.map((item) => {
          const isOpen = openItem === item.label;
          const hasChildren = Boolean(item.children?.length);
          return (
            <li key={item.label}>
              <div className="eduya-mobile-row">
                <NavLink
                  className={() => `eduya-mobile-link${isNavItemActive(location.pathname, item) ? ' active' : ''}`}
                  to={item.to}
                  onClick={closeMenu}
                >
                  {item.label}
                </NavLink>
                {hasChildren ? (
                  <button
                    type="button"
                    className={`eduya-mobile-toggle ${isOpen ? 'is-open' : ''}`}
                    aria-expanded={isOpen}
                    aria-label={`${item.label} submenu`}
                    onClick={() => setOpenItem(isOpen ? '' : item.label)}
                  >
                    <HiOutlineChevronDown />
                  </button>
                ) : null}
              </div>
              {hasChildren && isOpen && (
                <ul className="eduya-mobile-sublist">
                  {item.children.map((child) => (
                    <li key={child.to}>
                      <NavLink className="eduya-mobile-sublink" to={child.to} onClick={closeMenu}>
                        {child.label}
                      </NavLink>
                    </li>
                  ))}
                  {item.dropdownCta ? (
                    <li>
                      <Link className="eduya-mobile-cta" to={item.dropdownCta.to} onClick={closeMenu}>
                        {item.dropdownCta.label}
                      </Link>
                    </li>
                  ) : null}
                </ul>
              )}
            </li>
          );
        })}
      </ul>

      <Link to="/register-for-demo" className="eduya-cta eduya-cta-mobile" onClick={closeMenu}>
        Register for Demo
      </Link>
    </nav>
  );
}

export default Mobilemenu;
